import {createSelector} from '@ngrx/store';
import {selectAnamneseState} from './anamnese.reducer';
import { selectPatientEntities } from 'libs/patients/src/lib/store/patient.reducer';
import { PatientModel } from 'libs/tm-common/src/lib/models/patient.model';

export const selectAnamneseProductOptions = createSelector(
	selectAnamneseState,
	anamnese => anamnese.product?.options
			? anamnese.product.options
			: {}
);

export const selectAnamneseCustomOptions = createSelector(
	selectAnamneseState,
	anamnese => anamnese.product?.options?.custom
			? anamnese.product.options.custom
			: {}
);

export const selectAnamneseJaws = createSelector(
	selectAnamneseState,
	anamnese => ({uj: anamnese.product.options.uj, lj: anamnese.product.options.lj }) );

export const selectAnamneseDataTransfer = createSelector(
	selectAnamneseState,
	anamnese => ({dataTransfer: anamnese.product.options.dataTransfer}) );

export const selectAnamneseUploadedFiles = createSelector(
	selectAnamneseState,
	anamnese => anamnese.uploadedFiles );

export const selectAnamneseUploadedFunctionALFiles = createSelector(
	selectAnamneseState,
	anamnese => anamnese.uploadedFilesFunctionAL );

export const selectAnamnesePatientId = createSelector(
	selectAnamneseState,
	anamnese => anamnese.patientId
);

export const selectAnamnesePatient = createSelector(
	selectPatientEntities,
	selectAnamnesePatientId,
	(patients, id) => id  ? <PatientModel>patients[id] : null
);

export const selectAnamneseProductKey = createSelector(
	selectAnamneseState,
	({product}) => product?.key ?? null
);

export const selectAnamneseQuestionaireAnswers = createSelector(
	selectAnamneseState,
	anamnese => anamnese.questionaireAnswers ?? {}
);

export const selectAnamneseQuestionnaireFunctionALAnswers = createSelector(
	selectAnamneseState,
	anamnese => anamnese.questionnaireAnswersFunctionAL ?? null
);

export const selectAnamneseQuestionnaireMichiganSplintAnswers = createSelector(
	selectAnamneseState,
	anamnese => anamnese.questionnaireAnswersMichigan ?? null
);

export const selectAnamneseQuestionairePreparedAnswers = createSelector(
	selectAnamneseState,
	anamnese => anamnese.questionairePreparedAnswers ?? {}
);


export const selectShippingCosts = createSelector(
	selectAnamneseState,
	anamnese => anamnese.shippingCosts
);

export const selectAnamneseSkipDataTransferFlag = createSelector(
	selectAnamneseState,
	anamnese => anamnese.skipDataTransferFlag ?? false
);
